module.exports = __webpack_public_path__ + "img/Vietnam-2.30c74018.jpg";